(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('nb-NO', {
        style: 'currency',
        currency: 'NOK',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    function updateStickyBar(selected) {
      var stickyPrice = document.querySelector('[data-mh-sticky-price]');
      if (stickyPrice && selected) {
        stickyPrice.textContent = formatPrice(selected.price);
      }
      var stickyVariant = document.querySelector('[data-mh-sticky-variant]');
      if (stickyVariant && selected) {
        stickyVariant.textContent = selected.title;
      }
    }

    document.addEventListener('click', function (e) {
      var box = e.target.closest('.mh-variant-box');
      if (!box) return;

      var picker = box.closest('.mh-variant-picker');
      if (!picker) return;

      var allBoxes = Array.from(picker.querySelectorAll('.mh-variant-box'));

      allBoxes.forEach(function (b) {
        b.classList.remove('mh-variant-box--active');
      });
      box.classList.add('mh-variant-box--active');

      var input = box.querySelector('input[type="radio"]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      var variantId = input && input.dataset.variantId;
      if (!variantId) return;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());

      var variantsScript = picker.querySelector('.mh-product-variants');
      if (!variantsScript) return;

      try {
        var variants = JSON.parse(variantsScript.textContent);
        var selected = variants.find(function (v) { return v.id == variantId; });
        if (!selected) return;

        var price = formatPrice(selected.price);

        document.querySelectorAll('span.price').forEach(function (el) {
          el.textContent = price;
        });

        document.querySelectorAll('.price__regular .price-item--regular, .price-item--regular').forEach(function (el) {
          el.textContent = price;
        });

        document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;
        });

        updateStickyBar(selected);

      } catch (err) {
        console.error('MH variant picker error:', err);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
